import { frontendURL } from '../../../../helper/URLHelper';
import AccountDomainIndex from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/account-domain'),
      meta: { permissions: ['administrator'] },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'account_domain_settings',
          component: AccountDomainIndex,
          meta: {
            permissions: ['administrator'],
            platformService: 'custom_domain',
          },
        },
      ],
    },
  ],
};
